// Compatibility export for existing callers. New shared surfaces import from
// src/shared/utils so the browser and Functions use one canonical builder.
import buildRegistrationUrl from "src/shared/utils/buildRegistrationUrl";

export type {
  RegistrationUrlParams,
  RegistrationUtmParams,
} from "src/shared/utils/buildRegistrationUrl";

export default buildRegistrationUrl;
